// extracted by mini-css-extract-plugin
export const amount = "RedemptionsModuleRowMobile__amount__guXYx font-faces__sansLight__-1Yzy font-faces__sans__uCf65";
export const atlasGrotesk = "'AtlasGrotesk'";
export const bold = "700";
export const headBgColorExternal = "var(--salt)";
export const headBgColorInternal = "var(--shade)";
export const headBgColorShrunkSidebar = "var(--slate)";
export const medium = "500";
export const redemptionsModuleRowMobile = "RedemptionsModuleRowMobile__redemptionsModuleRowMobile__LM7lX";
export const regular = "400";
export const sans = "'sans'";
export const semibold = "600";
export const serif = "'serif'";
export const textCenter = "RedemptionsModuleRowMobile__textCenter__CYzO-";